import { ArrowRight } from "@tamagui/lucide-icons";
import { XStack } from "tamagui";

import { Button } from "@/components";

export default function SkipOrSubmit({
  showSkip = true,
  showSubmit = false,
  submitDisabled = false,
  isLast,
  onSkip,
  onSubmit,
}: {
  showSkip?: boolean;
  showSubmit?: boolean;
  submitDisabled?: boolean;
  isLast: boolean;
  onSkip: () => void;
  onSubmit: () => void;
}) {
  return (
    <XStack gap="$200">
      {showSkip && (
        <Button mode="secondary" onPress={onSkip}>
          Skip
        </Button>
      )}
      {showSubmit && (
        <Button
          mode="primary"
          disabled={submitDisabled}
          aria-disabled={submitDisabled}
          aria-label={isLast ? "Submit answers" : "Continue"}
          onPress={onSubmit}
          paddingHorizontal="$100"
        >
          <ArrowRight
            size="$250"
            color={
              submitDisabled ? "$textButtonDisabled" : "$textButtonPrimary"
            }
          />
        </Button>
      )}
    </XStack>
  );
}
